export default "__VITE_ASSET__Cr4120by__"